import React from "react";
import DynamicTable2 from "../../components/DynamicTable2";
import { EmailInput, RadioButtonInput, PhoneNumberInput, CheckboxInput } from '../../components/FormInitiators';



const PensionForm1 = ({ formData, setFormData, onFormDataChange, onNext }) => {


  
  // Generic input handler
  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };





//////////////////////////////////////////////////////////////////////////////////////////////////////////////

  return (

    <div className='google_forms'>


      <div className="forms">

    <form className="seventh-pay-arrears-form">
      <h3>Employee Details</h3>

      <label>
        Full Name of the Employee:
        <input type="text" name="employeeName" placeholder="eg:-   First_Name   Father's_Name   Surname" value={formData.employeeName} onChange={handleInputChange}/>
      </label>

      <label>
        Full Name of the Father:
        <input type="text" name="fatherName" value={formData.fatherName} onChange={handleInputChange} />
      </label>


      <label>
      <EmailInput
          value={formData.email}
          onChange={handleInputChange}
        />
      </label>

      <label>
      <PhoneNumberInput
        value={formData.phoneNumber}
        onChange={handleInputChange}
        name="phoneNumber"
      />
      </label>


      <label>
        Address after Retirement:
        <textarea
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            rows={4}
            style={{ width: "100%" , backgroundColor: "white"}}
            placeholder="Enter full address"
          />
      </label>


      <label>
      <label style={{ display: "block", marginBottom: "0.5rem" }}>
    Gender:
  </label>
        <RadioButtonInput
          value={formData.gender} 
          onChange={handleInputChange}
          name="gender"  
          orientation="horizontal"  
          options={[
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' }
          ]}    
        />
      </label>

      <label>
        Nationality:
        <input type="text"  name="nationality" value={formData.nationality}  onChange={handleInputChange}/>
      </label>

      <label>
      Religion:
      <input type="text" name="religion" value={formData.religion} onChange={handleInputChange}/>
      </label>

      
      <label>
      Designation:
      <input type="text" name="designation" value={formData.designation} onChange={handleInputChange}/>
      </label>

      <label>
      Height:
      <input type="text" name="Height" value={formData.Height} onChange={handleInputChange}/>
      </label>


      <label>
      Special Mark on Body:
      <input type="text" name="splMark" value={formData.splMark} onChange={handleInputChange}/>
      </label>

      <label>
        Date of Birth:
        <div style={{ display: "flex", flexDirection: "column" }}>
              <input type="date" name="dateOfBirth" placeholder="date of birth" value={formData.dateOfBirth} onChange={handleInputChange}/>
        </div>
      </label>


      <label>
        <div style={{ display: "flex", gap: "5rem", width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
              <span>Adhar Number:</span>
              <input type="text" name="adharno" placeholder="xxxx xxxx xxxx xxxx" value={formData.adharno} onChange={handleInputChange}/>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
                <span>Pan Number</span>
                <input type="text" name="panno" value={formData.panno} onChange={handleInputChange}/>
        </div>
        </div>
      </label>

      <label>
        <div style={{ display: "flex", gap: "4rem" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
              <span>Employee code & sevarth ID:</span>
              <input type="text" name="employeecode"  value={formData.employeecode} onChange={handleInputChange}/>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
                <span>PF Account No</span>
                <input type="text" name="pfno" value={formData.pfno} onChange={handleInputChange}/>
        </div>
        </div>
      </label>

      <label>
        <div style={{ display: "flex", gap: "7rem" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
              <span>Date of appointment:</span>
              <input type="date" name="dateOfAppointment" placeholder="Date of Appointement" value={formData.dateOfAppointment || ""} onChange={handleInputChange}/>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
                <span>Date of Confirmation of service: </span>
                <input type="date" name="dateOfService" value={formData.dateOfService }  onChange={handleInputChange}/>
        </div>
        </div>
      </label>

      <label>
        Date of Retirement:
      <input type="date" name="dateOfRetirement" placeholder="Date of Retirement" value={formData.dateOfRetirement || ""} onChange={handleInputChange}/>
      </label>

      <label>
      <label style={{ display: "block", marginBottom: "0.5rem" }}>
    Type of Retirement:
  </label>
        <RadioButtonInput
          value={formData.typeOfRetirement} 
          onChange={handleInputChange}
          name="typeOfRetirement"  
          orientation="vertical"  
          options={[
            { value: 'Superannuation Retirement', label: 'Superannuation Retirement' },
            { value: 'Voluntary Retirement', label: 'Voluntary Retirement' }
          ]}    
        />
      </label>

      <label>
      Group/class of Post:
        <select name="classOfPost"  value={formData.classOfPost} onChange={handleInputChange}>
        <option value="" disabled >--</option>
          <option value="1">I</option>
          <option value="2">II</option>
          <option value="3">III</option>
          <option value="4">IV</option>
        </select>
      </label>

      <label>
      Place of Retirement:
        <input type="text" name="placeOfRetirement" value={formData.placeOfRetirement} onChange={handleInputChange}/>
      </label>
      
        <button className="seventh-pay-arrears-buttons-container" type="button" onClick={onNext}>
          Next
        </button>
    </form>
    </div>
    </div>
  );
};

export default PensionForm1 ;